import React from 'react';
import './TrialExpiredModal.css';

const ReviewingApplicationModal = ({ onClose }) => {
  const handleClose = () => {
    // Save dismiss timestamp in localStorage (expires after 7 days)
    const dismissKey = 'reviewing-application-dismissed';
    const dismissTimestamp = Date.now();
    localStorage.setItem(dismissKey, dismissTimestamp.toString());
    onClose();
  };

  return (
    <div className="trial-modal-overlay" onClick={handleClose}>
      <div className="trial-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="trial-modal-close" onClick={handleClose}>
          <i className="bi bi-x"></i>
        </button>
        
        <div className="trial-modal-icon" style={{ color: '#667eea' }}>
          <i className="bi bi-hourglass-split"></i>
        </div>
        
        <h2 className="trial-modal-title">Reviewing Your Application</h2>
        
        <p className="trial-modal-message">
          Thank you for applying for the Free Academic Plan. We are currently reviewing your application and will notify you within 7 days.
        </p>
        
        <p className="trial-modal-message">
          You can continue using DISGENET while we review your application.
        </p>
        
        <div className="trial-modal-actions">
          <button 
            className="btn-gradient-blue trial-modal-btn-primary" 
            onClick={handleClose}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewingApplicationModal;
